export const TIME_BUFFER_IN_MINUTES = 15
export const MEAL_COMPARISON_MINUTES_BEFORE = 60
export const MEAL_COMPARISON_MINUTES_AFTER = 180
export const MEAL_COMPARISON_EVENT_TYPES = ['activities', 'journal', 'meals']
